module.exports = __webpack_public_path__ + "static/img/2_2_1.d52b806f.jpg";